<template>
  <v-row>
    <v-col cols="12">
      <showIdeaProjectsStand 
        v-if="!loading && entrepreneurship.type_postulations_id===1" 
        :data="data" 
        :edition_aux="edition"/>

      <showIdeaProjectsSchoolsStand 
        v-if="!loading && entrepreneurship.type_postulations_id===2" 
        :data="data" 
        :edition_aux="edition"/>

      <showBusinessModelsStand
        v-if="!loading && entrepreneurship.type_postulations_id===3" 
        :data="data" 
        :edition_aux="edition"/>
    </v-col>

    <v-col cols="12" class="pt-8 d-sm-flex">
      <v-btn
        depressed
        color="primary"
        :block="$vuetify.breakpoint.xsOnly"
        class="mr-auto mt-2"
        :to="{ name: 'showEntrepreneurshipsEdition'}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>
      
      <v-spacer />
      
      <v-btn
        depressed
        :block="$vuetify.breakpoint.xsOnly"
        class="mr-2 mt-2"
        color="primary"
        :loading="loading_download"
        @click="downloadWindowPDF"
        >
        Descargar PDF
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
      >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'
  import download from 'downloadjs'
  const VUE_URL_API = process.env.VUE_APP_URL_API
  
  import showIdeaProjectsStand from '@/components/stand/showIdeaProjectsStand.vue'
  import showIdeaProjectsSchoolsStand from '@/components/stand/showIdeaProjectsSchoolsStand.vue'
  import showBusinessModelsStand from '@/components/stand/showBusinessModelsStand.vue'

  export default {
    name: 'showWindowAccepted',
    components: { 
      showIdeaProjectsStand,
      showIdeaProjectsSchoolsStand,
      showBusinessModelsStand},
    data: () => ({
      loading:true,
      loading_download: false,
      slug:'',
      edition_id:null,
      entrepreneurship_id:null,
      convocation_form_id:null,

      data:[],
      entrepreneurship:null,
      edition:[]
    }),

    methods:{
      async getWindowEntrepreneurship(){
        await axios.get('admin/edition/'+this.edition_id+'/entrepreneurships/'+this.entrepreneurship_id+'/window').then(response =>{
          this.data = response.data.data
          this.entrepreneurship = response.data.data.window
        }).catch(error => {
          console.log(error);
        })
      },

      async getWindowEntrepreneurshipEditionInfo(){
        await axios.get('admin/editions/'+this.edition_id).then(response =>{
          this.edition = response.data.edition
        }).catch(error => {
          console.log(error);
        })
      },

      async downloadWindowPDF(){
        this.loading_download=true
        let url = VUE_URL_API + '/admin/windows/'+this.entrepreneurship_id+'/generate-pdf'

        await axios.get(
          url, 
          {responseType: 'blob'}
        ).then((response) => {
          //window.open(URL.createObjectURL(response.data));
          const content = response.headers['content-type'];
          download(response.data, 'stand' , content)
          this.loading_download=false
        })
      }
    },

    created(){
       this.edition_id = this.$route.params.edition_id;
       this.entrepreneurship_id = this.$route.params.entrepreneurship_id;
       this.convocation_form_id = this.$route.params.convocation_form_id;

       Promise.all([
        this.getWindowEntrepreneurship(),
        this.getWindowEntrepreneurshipEditionInfo()
      ]).then(() => {
        this.loading = false
      }).catch((error) => {
        console.log(error)
      });
    },
  }
</script>
<style>
.images {
  position: fixed;
}
</style>